// src/context/PreviewContext.jsx
import React, { createContext, useContext, useState, useRef } from 'react';
import { projectPreviewData } from '../Data/projectPreviewData';

const PreviewContext = createContext(null);

export function PreviewProvider({ children, onProjectClick }) {
  // We starten met een geldige fallback key uit je nieuwe lijst
  const [activeCard, setActiveCard] = useState(projectPreviewData["physi"]);
  const [isVisible, setIsVisible] = useState(false);
  const floaterRef = useRef(null);

  const showPreview = (key) => {
    if (projectPreviewData[key]) {
      setActiveCard(projectPreviewData[key]);
      setIsVisible(true);
    }
  };



  const hidePreview = () => {
    setIsVisible(false);
  };

  const updatePosition = (e) => {
    if (floaterRef.current) {
      const x = e.clientX + 25;
      const y = e.clientY + 25;
      floaterRef.current.style.transform = `translate3d(${x}px, ${y}px, 0)`;
    }
  };

  const selectProject = (key) => {
    if (projectPreviewData[key] && onProjectClick) {
      setIsVisible(false);
      // Omdat de key nu de slug is (bijv. 'bouwplaats'), sturen we die direct door!
      onProjectClick(key); 
    }
  };

  return (
    <PreviewContext.Provider value={{ showPreview, hidePreview, updatePosition, selectProject }}>
      {children}

      <div 
        ref={floaterRef}
        className="global-showroom-floater showcase-card showcase-card-425"
        style={{ 
          opacity: isVisible ? 1 : 0, 
          visibility: isVisible ? 'visible' : 'hidden'
        }}
      >
        <div className="showcase-img-inner-wrapper">
          <img src={activeCard.img} alt={activeCard.h2} className="showcase-card-img" />
        </div>
        <div className="showcase-blue-overlay-box overlay-grad">
          <h3 className="h3-white">{activeCard.h3}</h3>
          <h2 className="h2-white">{activeCard.h2}</h2>
          <p className="p-white">{activeCard.p}</p>
        </div>
      </div>
    </PreviewContext.Provider>
  );
}

export const usePreview = () => useContext(PreviewContext);